// @flow
import _ from 'lodash';
import numeral from 'numeral';
import React, { useState } from 'react';

import { Button, Col, Row, Tooltip } from 'grab-ui';
import { downloadCsv, loweredObj } from 'omega-rtc/utils/ucd-utils';
import MetricsDownloadCsv from 'img/ucd_project_metrics_download_csv.svg';
import MetricsGrid from 'img/ucd_campaign_metrics_cards.svg';
import MetricsTable from 'img/ucd_campaign_metrics_table.svg';
import {
  CAMPAIGN_METRICS_CHART_CONFIG,
  CAMPAIGN_METRICS_FORMULA_PROPS,
  FIELD_TYPE,
  NUMBER_FORMAT,
} from 'omega-rtc/constants/ucd';
import UCDObjectiveLabel from 'omega-rtc/components/form/ucd/common/UCDObjectiveLabel';
import CampaignCommsMetricsView from './CampaignCommsMetricsView';

import './UCDHomePage.scss';
import './CampaignDetail.scss';

const MetricsPage = (props) => {
  const [tableView, setTableView] = useState(false);

  const {
    campaignView,
    campaignMetricsView,
    businessMetrics,
    campaignBizMetricsColumns,
    subObjective,
    campaignID,
  } = props;

  const displayChange = () => {
    setTableView(!tableView);
  };

  const download = (data) => {
    downloadCsv(
      campaignID,
      _.map(data, (channelData, channelName) => {
        return {
          channelName,
          ...channelData,
        };
      }),
      [
        'channelName',
        'sent',
        'received',
        'notifclick',
        'open',
        'ctaclick',
        'rates.notifclickRate',
        'rates.openRate',
        'rates.ctaclickRate',
      ],
    );
  };

  const commsMetrics = _.get(campaignMetricsView, 'comms', {});

  // metrics data
  // {channelName: 'push', open: 123, rates: {openRate: 0.4}}
  const flattenCommsMetrics = {};
  _.forEach(commsMetrics, (channelData, channelName) => {
    // rate formulas
    const rates = {};
    const loweredChannelData = loweredObj(channelData);
    _.forEach(CAMPAIGN_METRICS_FORMULA_PROPS, (prop) => {
      const config = _.get(
        CAMPAIGN_METRICS_CHART_CONFIG,
        `${channelName}.rates.${prop}`,
      );
      if (config) {
        rates[prop] =
          loweredChannelData[config.lhs] / loweredChannelData[config.rhs];
      } else {
        rates[prop] = undefined;
      }
    });
    flattenCommsMetrics[channelName] = {
      ...loweredChannelData,
      rates,
    };
  });

  const { objective } = campaignView;

  return (
    <div className="project-performance-metrics">
      <Row>
        <Col span={6}>
          <UCDObjectiveLabel
            objective={objective}
            subObjective={subObjective}
          />
        </Col>
        <Col
          className="project-page-metrics-download-icon"
          span={6}
          offset={12}
        >
          <Tooltip title="Download" placement="bottom">
            <Button
              className="downloadBtn"
              onClick={() => {
                download(flattenCommsMetrics);
              }}
              type="link"
            >
              {' '}
              <img alt="icon" src={MetricsDownloadCsv} />
            </Button>
          </Tooltip>
        </Col>
      </Row>
      <Row className="project-page-metrics-topbar">
        <table>
          <tr>
            {campaignBizMetricsColumns.map((column, index) => {
              const value = _.get(businessMetrics, column.key, 0);
              const format =
                column.type === FIELD_TYPE.CURRENCY
                  ? NUMBER_FORMAT.CURRENCY
                  : NUMBER_FORMAT.INTEGER;
              const isTextBold = index === 0;
              // for integer metrics like new_users, retained_users, we choose to round the number up
              // this is to avoid showing 0 value to the user when the metrics value is 0.xx, since 0 value will give people the impression that the metrics is not working
              const numValue =
                column.type === FIELD_TYPE.CURRENCY ? value : _.ceil(value);

              const formattedNumber = isTextBold ? (
                <strong>
                  <p>{numeral(numValue).format(format)}</p>
                </strong>
              ) : (
                <p>{numeral(numValue).format(format)}</p>
              );

              return (
                <td key={column.key}>
                  <span>{column.title}</span>
                  <p>{formattedNumber}</p>
                </td>
              );
            })}
          </tr>
        </table>
      </Row>
      <Row className="row-metrics-title">
        <Col span={8}>
          <h3>Channels</h3>
        </Col>
        <Col style={{ textAlign: 'right' }} span={4} offset={12}>
          <Tooltip
            title={tableView ? 'Grid View' : 'List View'}
            placement="bottom"
          >
            <Button
              className="switchMode"
              style={{ padding: 0 }}
              type="link"
              onClick={displayChange}
            >
              <img alt="icon" src={tableView ? MetricsTable : MetricsGrid} />
            </Button>
          </Tooltip>
        </Col>
      </Row>
      <Row style={{ marginTop: 0 }} className="">
        <CampaignCommsMetricsView
          metrics={flattenCommsMetrics}
          tableView={tableView}
        />
      </Row>
    </div>
  );
};

export default MetricsPage;
